export default __webpack_public_path__ + "static/media/Scientists_Row-3.018dd21b.png";